<template>
    <div class="item-information">
        <div class="card section">
            <div class="card-body">
                <div class="row">
                    <h5 class="col-12 text-uppercase bg-light text-center py-1">
                        Meta
                    </h5>
                    <div class="form-group col-12">
                        <label for="pageTitle">Page title</label>
                        <div class="input-group">
                            <input
                                id="pageTitle"
                                v-model="metaCopy.title"
                                type="text"
                                class="form-control"
                                dir="auto"
                                placeholder="Page title"
                            />
                        </div>
                    </div>
                    <div class="form-group col-12">
                        <label for="pageDescription">Page description</label>
                        <div class="input-group">
                            <textarea
                                id="pageDescription"
                                v-model="metaCopy.description"
                                type="text"
                                class="form-control rtl"
                                dir="auto"
                                rows="5"
                                placeholder="Page description"
                            />
                        </div>
                    </div>
                    <div class="form-group col-12">
                        <label for="canonicalUrl">Canonical URL</label>
                        <div class="input-group">
                            <input
                                id="canonicalUrl"
                                v-model="metaCopy.canonicalUrl"
                                type="text"
                                class="form-control"
                                dir="auto"
                                placeholder="Canonical URL"
                            />
                        </div>
                    </div>
                    <div class="form-group col-12">
                        <b-form-checkbox v-model="metaCopy.noFollow" switch>
                            No Follow
                        </b-form-checkbox>
                    </div>
                    <div class="form-group col-12">
                        <b-form-checkbox v-model="metaCopy.noIndex" switch>
                            No Index
                        </b-form-checkbox>
                    </div>
                    <div class="form-group col-12">
                        <label for="ogTitle">Open Graph title</label>
                        <div class="input-group">
                            <input
                                id="ogTitle"
                                v-model="metaCopy.ogTitle"
                                type="text"
                                class="form-control"
                                dir="auto"
                                placeholder="Open Graph title"
                            />
                        </div>
                    </div>
                    <div class="form-group col-12">
                        <label for="ogDescription">
                            Open Graph description
                        </label>
                        <div class="input-group">
                            <textarea
                                id="ogDescription"
                                v-model="metaCopy.ogDescription"
                                type="text"
                                class="form-control rtl"
                                dir="auto"
                                rows="5"
                                placeholder="Open Graph description"
                            />
                        </div>
                    </div>
                    <div class="form-group col-12">
                        <label for="ogImage">Open Graph image</label>
                        <media-chooser
                            v-model="metaCopy.ogImage"
                            type="image"
                        />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        metaData: {
            type: Object,
            required: false,
            default: () => ({})
        }
    },

    data() {
        return {
            metaCopy: {}
        };
    },

    watch: {
        metaCopy: {
            handler() {
                this.$emit('meta-change', this.metaCopy);
            },
            deep: true
        }
    },

    async created() {
        if (typeof this.metaData === 'object') {
            this.metaCopy = { ...this.metaData };
        }
    }
};
</script>
